"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _GrowthSuiteCatalogTableCell = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogTableCell"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _reactRedux = require("react-redux");

var TableRow = _styledComponents.default.tr.withConfig({
  displayName: "GrowthSuiteCatalogFeaturesTable__TableRow",
  componentId: "lla0h2-0"
})([":nth-child(even){background-color:", ";:hover{background-color:", ";}& > th{background-color:", ";}}:nth-child(odd){background-color:", ";:hover{background-color:", ";}& > th{background-color:", ";}}"], _colors.OLAF, _colors.OLAF, _colors.OLAF, _colors.GYPSUM, _colors.GYPSUM, _colors.GYPSUM);

var Table = _styledComponents.default.table.withConfig({
  displayName: "GrowthSuiteCatalogFeaturesTable__Table",
  componentId: "lla0h2-1"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);

var GrowthSuiteCatalogFeaturesTable = function GrowthSuiteCatalogFeaturesTable(_ref) {
  var edition = _ref.edition,
      hub = _ref.hub;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var merchIdForHubEdition = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][hub];
  var featureIds = Object.keys(_ImmutableMerchandiseIdMap.default[merchIdForHubEdition].features); // this logic splits the features list almost in half (but with 2 or 3 more features in the first half
  // so they will appear in two columns,  with 2 or 3 empty right side columns

  var leftSideFeatures = featureIds.slice(0, Math.ceil((featureIds.length + 2) / 2));
  var rightSideFeatures = featureIds.slice(Math.ceil((featureIds.length + 2) / 2));
  return _react.default.createElement(Table, null, _react.default.createElement("tbody", null, leftSideFeatures.map(function (_, i) {
    return _react.default.createElement(TableRow, {
      key: i
    }, _react.default.createElement(_GrowthSuiteCatalogTableCell.default, {
      merchandiseId: merchIdForHubEdition,
      featureId: leftSideFeatures[i],
      key: leftSideFeatures[i],
      hub: hub
    }), _react.default.createElement(_GrowthSuiteCatalogTableCell.default, {
      merchandiseId: merchIdForHubEdition,
      featureId: rightSideFeatures[i] || null,
      key: rightSideFeatures[i] || i,
      hub: hub
    }));
  })));
};

var _default = GrowthSuiteCatalogFeaturesTable;
exports.default = _default;
module.exports = exports.default;